import React from 'react'
import FilterMenu from 'components/filter-menu'

// What each event's prefix is called in the menu, in this order; any other prefix goes after, as it is.
const CATEGORIES: Array<[string, string]> = [
  ['hub', 'Hub'],
  ['document', 'Document'],
  ['table', 'Table'],
  ['member', 'Member'],
  ['policy', 'Permission'],
  ['user', 'User']
]

/** An event's own part, in words: "table.cell_updated" → "Cell updated". */
export const eventLabel = (eventType: string): string => {
  const verb = eventType.split('.').slice(1).join('.') || eventType
  const spaced = verb.replace(/_/g, ' ')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

/** The event types by category, in the menu's order. */
export const groupEvents = (eventTypes: string[]): Array<{ label: string; events: string[] }> => {
  const byPrefix = new Map<string, string[]>()
  eventTypes.forEach((eventType) => {
    const prefix = eventType.split('.')[0]
    byPrefix.set(prefix, [...(byPrefix.get(prefix) ?? []), eventType])
  })
  const known = CATEGORIES.filter(([prefix]) => byPrefix.has(prefix)).map(([prefix, label]) => ({
    label,
    events: byPrefix.get(prefix) ?? []
  }))
  const others = [...byPrefix.keys()]
    .filter((prefix) => !CATEGORIES.some(([known]) => known === prefix))
    .map((prefix) => ({ label: prefix.charAt(0).toUpperCase() + prefix.slice(1), events: byPrefix.get(prefix) ?? [] }))
  return [...known, ...others]
}

interface EventFilterProps {
  eventTypes: string[]
  /** The events chosen: [] for every event (the log unfiltered), null for none at all. */
  selected: string[] | null
  onChange: (selected: string[] | null) => void
  loading?: boolean
}

/** The audit log's event filter: the shared filter menu, its event types by category, in words. */
const EventFilter: React.FC<EventFilterProps> = ({ eventTypes, selected, onChange, loading }) => (
  <FilterMenu
    noun={{ one: 'event type', many: 'event types' }}
    groups={groupEvents(eventTypes).map((group) => ({
      label: group.label,
      options: group.events.map((eventType) => ({ value: eventType, label: eventLabel(eventType) }))
    }))}
    selected={selected}
    onChange={onChange}
    loading={loading}
  />
)

export default EventFilter
